export enum ModuleStatus {
  Initial = "Initial",
  Loading = "Loading",
  Refreshing = "Refreshing",
  Ready = "Ready",
  Error = "Error",
}
